export default {
  placesAndDirections: {
    'isochrones': 'Isócronas',
    'place': 'lugar',
    'notRouteFound': 'No ha sido posible encontrar una ruta que conecte los sitios utilizando el perfil seleccionado',
    'notRouteFoundWithFilters': 'No ha sido posible encontrar una ruta que conecte los sitios utilizando el perfil y los filtros seleccionados',
    'noPlaceFound': 'No se ha encontrado la ubicación del texto insertado',
    'routeReady': 'Ruta lista',
    'useLocation': 'GPS',
    'addPlaceInput': 'Añadir ubicación',
    'clearRoute': 'Eliminar la ruta',
    'reverseRoute': 'Invertir',
    'orderByClosestPlaces': 'Ordenar por lugares más cercanos',
    'calculatingRoute': 'Calculando ruta...',
    'yourLocation': 'Su ubicación',
    'expandAltitudeChart': 'Ampliar el gráfico',
    'errorRenderingContentUploaded': 'Error al mostrar el contenido cargado. Compruebe el formato y el contenido del archivo',
    'roundTrip': 'Ruta circular',
    'notPossibleToCalculateRoute': 'No se ha podido calcular una ruta utilizando uno de los lugares seleccionados',
    'apiError': {
      '2000': 'No se ha podido procesar la solicitud JSON',
      '2001': 'Falta un parámetro obligatorio',
      '2002': 'Formato incorrecto de los parámetros',
      '2003': 'Los parámetros de ruta superan uno o más límites. Recuerde que algunos elementos evitables tienen límites, como la longitud de la ruta y el área de un polígono a evitar que no debe exceder los 20000 kilómetros cuadrados.',
      '2004': 'Los parámetros de ruta superan uno o más límites. Recuerde que la distancia aproximada de la ruta no debe ser mayor a 6000 kms. Cuando se utilizan ciertas opciones de ruta o evitables, la distancia aproximada de la ruta no debe ser mayor a 150 kms.',
      '2006': 'No se puede analizar la solicitud y procesar la respuesta',
      '2007': 'Formato de respuesta no admitido',
      '2008': 'Elemento vacío',
      '2009': 'No fue posible encontrar una ruta adecuada para los lugares y criterios especificados. Puede que el perfil seleccionado no es admitido en esta zona/región con los filtros aplicados.',
      '2010': 'No se pudo encontrar un punto adecuado para procesar la ruta. Puede que uno de los puntos seleccionados no sea enrutable o que el perfil seleccionado no sea compatible con esta región.',
      '2011': 'Cuando se utiliza la opción de rutas alternativas, no se pueden establecer paradas adicionales',
      '2012': 'Se ha especificado un parámetro no válido. Asegúrese de que la URL es correcta',
      '2099': 'No se puede calcular la ruta'
    },
    'genericErrorMsg': 'No se puede calcular la ruta',
    'reorder': 'Reordenar',
    timeoutError: 'La solicitud tardó demasiado y se canceló. Intente con distancias más cortas.'
  }
}
